import { useEventContext } from 'context/EventContext';
import { useSession } from 'next-auth/react';
import { useEffect } from 'react';
import {
  buildUnifiedLoginCompletion,
  consumeUnifiedLogin,
} from 'shared-utils/unifiedLoginAnalytics';

export default function UnifiedLoginAnalytics() {
  const { data: session, status } = useSession();
  const { sendEvent } = useEventContext();
  const outcome = session?.user?.redirectAuth;
  useEffect(() => {
    if (
      status !== 'authenticated' ||
      session?.user?.provider !== 'g2' ||
      !outcome ||
      !consumeUnifiedLogin(outcome, 'getapp')
    )
      return;
    try {
      Promise.resolve(
        sendEvent({
          ...buildUnifiedLoginCompletion(outcome),
          site_id: 'GetApp',
          event: 'email_capture',
          eventName: 'email_capture',
          eventGA4Name: 'email_capture',
        })
      ).catch(() => undefined);
    } catch {
      // Analytics must never interrupt authentication.
    }
  }, [outcome, status, session?.user?.provider, sendEvent]);
  return null;
}
